import useSWR from 'swr';
import { EngineService } from '@/services/engine/engine-service';
import { SystemOverview } from '@/types/system';
import { CACHE_KEYS } from '@/constants/cache-keys';

export function useSystemOverview() {
    const { data, isLoading, error, mutate } = useSWR<SystemOverview>(
        [CACHE_KEYS.SYSTEM_OVERVIEW],
        () => EngineService.getSystemOverview(),
        {
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
        },
    );

    return {
        data,
        isLoading,
        error,
        mutate,
    };
}
